<template>
    <div>
        <div class="d-flex flex-stack flex-wrap">
            <div class="page-title d-flex flex-column me-3 mt-3"> 
                <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('product_bundle_transactions') }}</h1>  
                <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
                    <li class="breadcrumb-item text-gray-600">
                        <a href="#" class="text-gray-600 text-hover-primary">
                            <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                        </a>
                    </li> 
                    <li class="breadcrumb-item text-primary">{{ $t('transactions') }}</li>     
                    <li class="breadcrumb-item text-gray-600">{{ $t('product_bundle_transactions') }}
                    <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon>
                    </li> 
                </ul> 
            </div> 
        </div>
        <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
            <div class="row p-10">
                <div class="col-lg-8">
                    <form class="form fv-plugins-bootstrap5 fv-plugins-framework p-3 pb-0 pt-1 rounded-2">
                        <div class="fv-row mb-7 row">
                            <div class="col-lg col-md-4 col-sm-6 col-xs-12">
                                <label class="fw-bold form-label mt-3">
                                    <span>{{ $t('stock_account') }}</span>
                                </label>
                                <Select2 v-model="form.account_id" :options="accountList"  :settings="{ width: '100%' }"/>
                            </div>
                            <div class="col-lg col-md-4 col-sm-6 col-xs-12">
                                <label class="fs-6 fw-bold form-label mt-3">
                                    <span>{{ $t('start_date') }}</span>
                                </label>
                                <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.start_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" :enableTimePicker="false"></Datepicker>  
                            </div>
                            <div class="col-lg col-md-4 col-sm-6 col-xs-12">
                                <label class="fs-6 fw-bold form-label mt-3">
                                    <span>{{ $t('end_date') }}</span>
                                </label>
                                <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.end_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" :enableTimePicker="false"></Datepicker>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-lg-4">
                    <div class="d-flex flex-wrap justify-content-lg-end justify-content-center mt-8" data-kt-customer-table-toolbar="base">
                        <Popper hover placement="top">
                            <button type="button" class="btn btn-light border border-gray-300 btn-icon me-3" @click="this.setCriteriasToDefault()">
                                <i class="bi bi-eraser-fill fs-4"> </i>
                            </button>
                            <template #content>
                                <span class="text-gray-800"> {{ $t('reset_all_criterias') }} </span>
                            </template>
                        </Popper>
                        <button type="button" class="btn btn-light-primary border border-primary" @click="getProductTransactions()" data-kt-indicator="on">
                            <span class="svg-icon svg-icon-muted"><svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect y="6" width="16" height="3" rx="1.5" fill="currentColor"/>
                            <rect opacity="0.3" y="12" width="8" height="3" rx="1.5" fill="currentColor"/>
                            <rect opacity="0.3" width="12" height="3" rx="1.5" fill="currentColor"/>
                            </svg>
                            </span>
                            <span v-if="!this.isListProgressing"> {{ $t('list_transactions') }} </span> 
                            <span class="indicator-progress" v-if="this.isListProgressing">
                                {{ $t('getting_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span> 
                        </button>
                        <div class="dropdown" v-if="this.$isCredentialActive(16,'D')" >
                            <button class="btn btn-light-info fw-bold border border-info dropdown-toggle ms-3" data-bs-toggle="dropdown" aria-expanded="true" id="cashActions" type="button"
                                :disabled="this.selectedRowKeys.length == 0">
                                <span class="svg-icon svg-icon-muted">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path opacity="0.3" d="M22.1 11.5V12.6C22.1 13.2 21.7 13.6 21.2 13.7L19.9 13.9C19.7 14.7 19.4 15.5 18.9 16.2L19.7 17.2999C20 17.6999 20 18.3999 19.6 18.7999L18.8 19.6C18.4 20 17.8 20 17.3 19.7L16.2 18.9C15.5 19.3 14.7 19.7 13.9 19.9L13.7 21.2C13.6 21.7 13.1 22.1 12.6 22.1H11.5C10.9 22.1 10.5 21.7 10.4 21.2L10.2 19.9C9.4 19.7 8.6 19.4 7.9 18.9L6.8 19.7C6.4 20 5.7 20 5.3 19.6L4.5 18.7999C4.1 18.3999 4.1 17.7999 4.4 17.2999L5.2 16.2C4.8 15.5 4.4 14.7 4.2 13.9L2.9 13.7C2.4 13.6 2 13.1 2 12.6V11.5C2 10.9 2.4 10.5 2.9 10.4L4.2 10.2C4.4 9.39995 4.7 8.60002 5.2 7.90002L4.4 6.79993C4.1 6.39993 4.1 5.69993 4.5 5.29993L5.3 4.5C5.7 4.1 6.3 4.10002 6.8 4.40002L7.9 5.19995C8.6 4.79995 9.4 4.39995 10.2 4.19995L10.4 2.90002C10.5 2.40002 11 2 11.5 2H12.6C13.2 2 13.6 2.40002 13.7 2.90002L13.9 4.19995C14.7 4.39995 15.5 4.69995 16.2 5.19995L17.3 4.40002C17.7 4.10002 18.4 4.1 18.8 4.5L19.6 5.29993C20 5.69993 20 6.29993 19.7 6.79993L18.9 7.90002C19.3 8.60002 19.7 9.39995 19.9 10.2L21.2 10.4C21.7 10.5 22.1 11 22.1 11.5ZM12.1 8.59998C10.2 8.59998 8.6 10.2 8.6 12.1C8.6 14 10.2 15.6 12.1 15.6C14 15.6 15.6 14 15.6 12.1C15.6 10.2 14 8.59998 12.1 8.59998Z" fill="currentColor"/>
                                    <path d="M17.1 12.1C17.1 14.9 14.9 17.1 12.1 17.1C9.30001 17.1 7.10001 14.9 7.10001 12.1C7.10001 9.29998 9.30001 7.09998 12.1 7.09998C14.9 7.09998 17.1 9.29998 17.1 12.1ZM12.1 10.1C11 10.1 10.1 11 10.1 12.1C10.1 13.2 11 14.1 12.1 14.1C13.2 14.1 14.1 13.2 14.1 12.1C14.1 11 13.2 10.1 12.1 10.1Z" fill="currentColor"/>
                                    </svg>
                                </span>
                                {{$t('delete_actions')}}
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="deleteActions">
                                <li>
                                    <button class="dropdown-item fw-bold fs-6 p-2" :class="{'text-danger': this.selectedRowKeys.length > 0}" @click="this.deleteItem()" :disabled="this.selectedRowKeys.length == 0">
                                        {{ $t('delete_selected') }} <span v-if="productList != null">({{ this.selectedRowKeys.length }})</span>
                                    </button>
                                </li>
                                <div class="separator opacity-75"></div>
                                <li>
                                    <button class="dropdown-item text-wrap fw-bold fs-6 p-2" @click="deleteAllRelated()" :disabled="this.selectedSourceKeys.length == 0">
                                        {{ $t('delete_all_selected_and') }}
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            
                <div class="separator my-5 mt-0 border-gray-300" style="margin-top: -10px !important;"></div>
                <div class="table-responsive min-h-300px">                
                    <ListOptions :expandedRowDetail="expandedRowDetail" :expandedView="true" @toggle-expand="toggleExpanded" :name="this.$options.name" ref="listOptionComponent"></ListOptions>                         
                        <DxDataGrid id="gridContainer" :key="$i18n.locale" :show-borders="true" 
                            key-expr="id" 
                            :data-source="productList" 
                            :allow-column-reordering="true"  
                            :allow-column-resizing="true" 
                            :column-auto-width="true" 
                            :row-alternatin-enabled="true"
                            :hover-state-enabled="true" 
                            :show-row-lines="true" 
                            :expandedRowKeys="expandedRowKeys"
                            :ref="'dxBundleTransactionList'"
                            @exporting="this.$onExporting($event , 'Product-Transaction-List')"
                            :v-model:selected-row-keys="selectedRowKeys"
                            @selection-changed="onSelectionChanged"
                            @row-expanding="onRowExpanding"> 

                            <DxSummary :calculate-custom-summary="setSummariesMaster">
                                <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="transaction_date"/>
                                <DxGroupItem
                                    :show-in-group-footer="true"
                                    name="quantity1"
                                    summary-type="custom"
                                    show-in-column="quantity1"
                                    display-format="{0}"
                                /> 
                                <DxGroupItem
                                    :show-in-group-footer="true"
                                    name="price"
                                    summary-type="custom"
                                    show-in-column="price"
                                    display-format="{0}"
                                /> 
                                <DxTotalItem
                                    name="quantity1"
                                    summary-type="custom"
                                    show-in-column="quantity1"
                                    display-format="{0}"
                                />
                                <DxTotalItem
                                    name="price"
                                    summary-type="custom"
                                    show-in-column="price"
                                    display-format="{0}"
                                />
                            </DxSummary>
                           
                            <DxFilterRow :visible="true"/>
                            <DxHeaderFilter :visible="true"/>
                            <DxGroupPanel :visible="false"/>      
                            <DxExport :enabled="false" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                            <DxSearchPanel :visible="false"/>
                            <DxScrolling
                                mode="virtual"
                                row-rendering-mode="virtual"
                            />
                            <DxToolbar>
                                <DxItem location="before">
                                <DxButton
                                    :disabled="selectedRowKeys.length === 0"                                        
                                    :text="$t('deselect_all')   + ' ('+ selectedRowKeys.length + ')'"
                                    @click="clearSelection"
                                />
                                </DxItem>
                            </DxToolbar>
                            <DxSelection mode="multiple" select-all-mode="allPages" :show-check-boxes-mode="this.$isCredentialActive(16,'D') ? 'always' : 'none'"/>
                            <DxColumn data-field="transaction_date"  data-type="date" alignment="right" format="dd.MM.yyyy" :caption="$t('transaction_date')" />
                            <DxColumn data-field="stock_account_name" :caption="$t('stock_account')"/>
                            <DxColumn data-field="transaction_type_name" :caption="$t('transaction_type')" /> 
                            <DxColumn data-field="transaction_no" :caption="$t('transaction_no')" />
                            <DxColumn data-field="invoice_type_name" :caption="$t('source')" /> 
                            <DxColumn data-field="invoice_no" :caption="$t('source_no')" /> 
                            <DxColumn data-field="in_out_name" :caption="$t('in_out')" />  
                            <DxColumn data-field="currency" :caption="$t('currency')" />
                            <DxColumn data-field="quantity1" :sorting-method="this.$numericSort" :caption="$t('qty')"  alignment="right" />
                            <DxColumn data-field="price" :sorting-method="this.$numericSort" :caption="$t('price')" alignment="right" />
                            <DxColumn data-field="net_price" :sorting-method="this.$numericSort" :caption="$t('net_price')" alignment="right" />
                            <DxColumn data-field="description" :caption="$t('description')" />

                            <DxMasterDetail
                                :enabled="true"
                                :autoExpandAll="this.expandedRowDetail.autoExpandAll"
                                template="masterDetailTemplate"
                            />

                            <template #masterDetailTemplate="{ data }"> 
                                <DxDataGrid :data-source="data.data.detailList" key-expr="id"  :show-borders="true" :column-auto-width="true" >
                                    <DxColumn cssClass="bg-light-blue-grey" data-field="transaction_date"  data-type="date" alignment="right" format="dd.MM.yyyy" :caption="$t('transaction_date')" />
                                    <DxColumn cssClass="bg-light-blue-grey" data-field="stock_account_name" :caption="$t('stock_account')" cell-template="stock-account-name-cell-template"/>
                                    <DxColumn cssClass="bg-light-blue-grey" data-field="transaction_type_name" :caption="$t('transactions_type')" /> 
                                    <DxColumn cssClass="bg-light-blue-grey" data-field="transaction_no" :caption="$t('transaction_no')" />
                                    <DxColumn cssClass="bg-light-blue-grey" data-field="in_out_name" :caption="$t('in_out')" />  
                                    <DxColumn cssClass="bg-light-blue-grey" data-field="currency" :caption="$t('currency')" />
                                    <DxColumn cssClass="bg-light-blue-grey" data-field="quantity1" :sorting-method="this.$numericSort" :caption="$t('qty')"  alignment="right" />
                                    <DxColumn cssClass="bg-light-blue-grey" data-field="price" :sorting-method="this.$numericSort" :caption="$t('price')" alignment="right" />
                                    <DxColumn cssClass="bg-light-blue-grey" data-field="net_price" :sorting-method="this.$numericSort" :caption="$t('net_price')" alignment="right" />
                                    <DxColumn cssClass="bg-light-blue-grey" data-field="description" :caption="$t('description')" />

                                    <template #stock-account-name-cell-template="{ data }"> 
                                        <span class="text-gray-900"> 
                                            {{ data.data.stock_account_name }} 
                                        </span> 
                                        <small v-if="data.data.is_bundle_product == 1" class="ms-2 badge badge-sm badge-success">Bundle</small>
                                    </template>
                                    
                                <DxSummary :calculate-custom-summary="setSummariesMasterDetail">
                                    <DxTotalItem column="id" summary-type="count" show-in-column="transaction_date" :display-format="`${$t('record')} : {0}`"/>
                                    <DxTotalItem  
                                        name="quantity1"
                                        summary-type="custom"
                                        show-in-column="quantity1"
                                        display-format="{0}" />
                                    <DxTotalItem 
                                        name="price"
                                        summary-type="custom"
                                        show-in-column="price"
                                        display-format="{0}" />
                                </DxSummary>

                                </DxDataGrid>
                            </template>
                            <DxToolbar>
                                <DxItem location="before">
                                <DxButton
                                    :disabled="selectedRowKeys.length === 0"                                        
                                    :text="$t('deselect_all')   + ' ('+ selectedRowKeys.length + ')'"
                                    @click="clearSelection"
                                />
                                </DxItem>
                            </DxToolbar>
                        </DxDataGrid>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"; 
import moment from 'moment';
import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxColumn, DxScrolling, DxMasterDetail, DxToolbar, DxSelection, DxItem, DxSummary, DxTotalItem  } from 'devextreme-vue/data-grid';
import DxButton from 'devextreme-vue/button';

export default {
    name: "ProductTransactionList",
    components:{
        DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxColumn, DxScrolling, DxMasterDetail, DxToolbar, DxSelection, DxItem, DxSummary, DxTotalItem, DxButton
    },
    data() {
        return {
            storageKey: 'dx_' + this.$options.name,
            productList:[],
            form:{
                start_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
                end_date: moment(),
                account_id: '-1'
            },
            accountList: [],
            selectedRowKeys: [],
            selectedSourceKeys: [],
            menuSelection: '/DeleteMultipleProductTransactionHelppage',
            expandedRowKeys: [],
            expandedRowDetail:{
                autoExpandAll : false,
                listControl : false
            }
        }
    },
    computed:{
        dataGrid: function() {
            return this.$refs["dxBundleTransactionList"].instance;
        }
    },
    methods:{
        getData() {
            const params = {
                session_id : this.$getUser().session_id,
                account_type : 7, // Stock: 7
            };  
            axios.post('api/GetCompanyAccounts/GetStockAccounts', params, {'Content-Type': 'application/json'})
            .then((response) => { 
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){ 
                    this.accountList = response.data.account_data;
                    this.accountList.forEach(element => {
                        element.name = this.$unlock(element.name);
                        element.account_id = this.$unlock(element.account_id);
                        element.text = this.$unlock(element.text);
                        this.expandedRowKeys = element.id;
                    });
                    this.accountList.unshift({ id: -1, text: this.$t('all')}); 
                }
            })
            .catch((error) => {
                console.error(error);
            }); 
        },
        getProductTransactions(){
            this.productList = []
            const params = {
                session_id : this.$getUser().session_id,
                start_date: this.form.start_date,
                end_date: this.form.end_date,
                account_id: this.form.account_id == '-1' ? null : this.form.account_id,
            };
            axios.post('api/Transaction/GetProductTransactions', params, {'Content-Type': 'application/json'})
            .then((response) => {
                this.productList = response.data;
                this.expandedRowDetail.listControl = this.productList.length > 0 ? true : false;
                this.$refs["dxBundleTransactionList"].instance.collapseAll(-1);
                
            })
            .catch((error) => {
                console.error(error);
            });
        },
        setCriteriasToDefault() {   
            this.productList = [];
            this.form = {
                start_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
                end_date: moment(),
                account_id: '-1'
            };
            this.getProductTransactions();
        },
        deleteItem() {
            this.$swal.fire({
                title: this.$t('are_you_sure_you_want_to_delete_this_bundle_transaction'),
                confirmButtonColor: "#f1416c",
                showDenyButton: false,
                showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
                confirmButtonText: this.$t('delete'),
                icon: 'info'
            })
            .then((result) => {
                if (result.isConfirmed) { 
                this.$Progress.start();
                const params = { 
                    session_id: this.$getUser().session_id,
                    header_id: this.selectedRowKeys
                };
                axios.post('api/Transaction/BundleTransactionMultiDelete', params, {'Content-Type': 'application/json'})
                .then(() => {
                    this.getProductTransactions();
                    this.$Progress.finish(); 
                })
                .catch(() => {
                    this.$Progress.finish();
                });  
            }
            });
        }, 
        deleteAllRelated() {
            this.$swal.fire({
                title: this.$t('are_you_sure_you_want_to_delete_transaction'),
                confirmButtonColor: "#f1416c",
                showDenyButton: false,
                showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
                confirmButtonText: this.$t('delete'),
                icon: 'info'
            })
            .then((result) => {
                if (result.isConfirmed) { 
                this.$Progress.start();
                const params = { 
                    session_id: this.$getUser().session_id,
                    source_transaction_id: this.selectedSourceKeys
                };
                axios.post('api/Transaction/BundleTransactionMultiRelatedDelete', params, {'Content-Type': 'application/json'})
                .then(() => {
                    this.getProductTransactions();
                    this.$Progress.finish(); 
                })
                .catch(() => {
                    this.$Progress.finish();
                });  
            }
            });
        }, 
        onSelectionChanged(e) {
            const selectedKeys = e.selectedRowsData.map(row => row.transaction_type_id);
            const selectedSourceKeys = e.selectedRowsData.map(row => row.source_transaction_id);
            this.selectedRowKeys = selectedKeys;
            this.selectedSourceKeys = selectedSourceKeys;
            e.selectedRowsData.forEach(row => {
                e.component.deselectRows([row.transaction_type_id]);
            });

        },
        clearSelection() {
            this.selectedRowKeys = [];            
            const dataGrid = this.$refs["dxBundleTransactionList"].instance;
            dataGrid.clearSelection();
        },
        async onRowExpanding(e) {
            const rowId = e.key;
            const rowData = this.productList.find(item => item.id === rowId);  
            const transactionTypeId = rowData ? rowData.transaction_type_id : null; 

            const parameters = {
                session_id: this.$getUser().session_id,
                transaction_type_id: transactionTypeId
            };  
            axios.post('/api/Transaction/GetBundleDetail', parameters, {'Content-Type': 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                    const dataSource = this.dataGrid.getDataSource();
                    this.productList.forEach(element => {
                        if(element.id == rowId) {
                            element.detailList = response.data;
                        }
                        this.expandedRowKeys = element.id;
                    });
                    dataSource.reload();
                }
            })
            .catch((error) => {
                console.error(error);
            });
        },
        setSummariesMaster(options){  
            const optionNames = ["quantity1", "price"]; 
            optionNames.forEach(item => {
                if(options.name == item){
                    if(options.summaryProcess === 'start'){ options.totalValue = 0; }
                    else if(options.summaryProcess === 'calculate'){
                        var itemValue = parseFloat(options.value[item].replaceAll(',', ''));
                        (options.totalValue += itemValue);
                    }
                    else if(options.summaryProcess === 'finalize'){ 
                        options.totalValue = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(options.totalValue);
                    }
                }
            });
        },
        setSummariesMasterDetail(options){  
            const optionNames = ["quantity1", "price"]; 
            optionNames.forEach(item => {
                if(options.name == item){
                    if(options.summaryProcess === 'start'){ options.totalValue = 0; }
                    else if(options.summaryProcess === 'calculate'){
                        var itemValue = parseFloat(options.value[item].replaceAll(',', ''));
                        (options.totalValue += itemValue);
                    }
                    else if(options.summaryProcess === 'finalize'){ 
                        options.totalValue = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(options.totalValue);
                    }
                }
            });
        },
        toggleExpanded() {
            this.expandedRowDetail.autoExpandAll = !this.expandedRowDetail.autoExpandAll;
            this.expandedRowDetail.autoExpandAll == true ? this.expandedControl(1) : this.expandedControl() 
        },
        expandedControl(value) {
                if (value == 1) {
                this.expandedRowKeys = this.productList.map(item => item.id); 
                    Promise.all(this.productList.map(item => this.onRowExpanding({ key: item.id })))
                        .then(() => {
                            this.expandedRowKeys = [...this.expandedRowKeys]; 
                            this.$nextTick(() => {
                                this.expandedRowDetail.autoExpandAll = true;
                                this.dxGrid.repaint();
                            });
                        })
                        .catch(error => {
                            console.error( error);
                        });
                }else{
                    this.expandedRowKeys = [];
                    this.$nextTick(() => {
                        this.expandedRowDetail.autoExpandAll = false;
                        this.dxGrid.repaint();
                    });
                }
            }
    },
    created() { 
        this.getData();
    }
}
</script>
